import Vue from 'vue'
import Myweb from '@/views/myweb/index.vue'
// import Router from 'vue-router'
import Home from '@/views/base/home/home.vue'

// Vue.use(Router)
// // 解决路由重复
// //获取原型对象上的push函数
// const originalPush = Router.prototype.push
// //修改原型对象中的push方法
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

export default [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    // 登录
    path: '/login',
    name: 'login',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/base/login/login.vue')
  },
  {
    // 忘记密码
    path: '/forgetpwd',
    name: 'forgetpwd',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/views/base/login/forget-pwd.vue'
      )
  },
  {
    // 注册
    path: '/register',
    name: 'register',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/base/login/register.vue')
  },
  // 购物车
  {
    path: '/shoppingCart',
    name: 'shoppingCart',
    component: () => import('@/views/shoppingCart/index.vue')
  },
  // 订单结算
  {
    path: '/orderInformation',
    name: 'orderInformation',
    component: () => import('@/views/orderInformation/orderInformation.vue')
  },
  // 订单详情
  {
    path: '/orderDetails',
    name: 'orderDetails',
    component: () => import('@/views/orderDetails/orderDetails.vue')
  },
  // 理赔申请
  {
    path: '/claim',
    name: 'claim',
    component: () => import('@/views/claim/index.vue')
  },
  {
    path: '/claimSolid',
    name: 'claimSolid',
    component: () => import('@/views/claimSolid/index.vue')
  },
  // 售后-退款处理
  {
    path: '/refunddispose',
    name: 'refunddispose',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/refunddispose/index.vue')
  },
  // 售后-退货处理
  {
    path: '/salesreturn',
    name: 'salesreturn',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/salesreturn/index.vue')
  },
  // 卖家处理退款
  {
    path: '/saleshandlereturn',
    name: 'saleshandlereturn',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/views/saleshandlereturn/index.vue'
      )
  },
  {
    // 自营专区
    path: '/supportself',
    name: 'supportself',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/supportself/index.vue')
  },
  {
    // 自营活动
    path: '/activity',
    name: 'activity',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/activity/index.vue')
  },
  {
    // 配件详情
    path: '/Partsdetails',
    name: 'Partsdetails',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/Partsdetails/index.vue')
  },
  {
    // 配件详情
    path: '/PartsdetailsGroup',
    name: 'PartsdetailsGroup',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/PartsdetailsGroup/index.vue')
  },
  {
    // 询报价
    path: '/askquote',
    name: 'askquote',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/askquote/index.vue')
  },
  {
    // 我的关注
    path: '/attention',
    name: 'attention',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/attention/index.vue')
  },
  // 明觉
  {
    path: '/mingjue',
    name: 'mingjue',
    component: () => import('@/views/base/common/mingjue.vue')
  },
  // 007
  {
    path: '/catalogue',
    name: 'catalogue',
    component: () => import('@/views/catalogue/index.vue')
  },
  {
    // 股东联盟
    path: '/shareholder',
    name: 'shareholder',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/shareholder/index.vue')
  },
  {
    // 极配汇
    path: '/JPremit',
    name: 'JPremit',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/JPremit/index.vue')
  },
  {
    // 配件查询
    path: '/partsSearch',
    name: 'partsSearch',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/partsSearch/index.vue')
  },
  // 配件分类导航
  {
    path: '/partsNavigation',
    name: 'partsNavigation',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/views/partsNavigation/index.vue'
      )
  },
  {
    // 店铺查询
    path: '/storeSearch',
    name: 'storeSearch',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/storeSearch/index.vue')
  },
  {
    // VIN码查询
    path: '/VINSearch',
    name: 'VINSearch',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/VINSearch/index.vue')
  },
  {
    // 推荐品牌
    path: '/recommended-brand',
    name: 'recommended-brand',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/views/recommended-brand/index.vue'
      )
  },
  {
    // 店铺首页
    path: '/homePage',
    name: 'homePage',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/homePage/index.vue')
  },
  {
    // 全部商品
    path: '/storeGoods',
    name: 'storeGoods',
    component: () =>
      import(
        /* webpackChunkName: "about" */ '@/views/homePage/components/storeGoods/index.vue'
      )
  },
  {
    // 支付订单
    path: '/payOrder',
    name: 'payOrder',
    component: () =>
      import(/* webpackChunkName: "about" */ '@/views/payOrder/index.vue')
    // redirect: 'payOrder'
    // children: [

    // ]
  },
  {
    path: '/payStatus',
    name: 'payStatus',
    component: () =>
      import(/* webpackChunkName: "myweb" */ '@/views/payOrder/payStatus.vue')
  },
  // 再次购买
  {
    path: '/buyAgain',
    name: 'buyAgain',
    component: () =>
      import(/* webpackChunkName: "myweb" */ '@/views/buyAgain/index.vue')
  },
  // 我的极联
  {
    path: '/myweb',
    name: 'my_web',
    component: Myweb,
    meta: {
      title: '会员中心',
      listShow: true
    },
    redirect: '/myweb_index',
    children: [
      {
        path: '/myweb_index',
        name: 'myweb_index',
        mark: 'WSS-1',
        meta: {
          title: '后台首页',
          notCache: true
        },
        component: () =>
          import(/* webpackChunkName: "myweb" */ '@/views/myweb/single-page')
      }
    ]
  },
  {
    path: '/myweb_index',
    name: 'myweb_index',
    mark: 'WSS-1',
    redirect: '/myweb_index',
    component: Myweb,

    meta: {
      title: '后台首页',
      listShow: true,
      icon: 'icon-a-lianhe6'
    },
    component: () =>
      import(/* webpackChunkName: "myweb" */ '@/views/myweb/single-page')
  },
  {
    path: '/test1',
    name: 'myweb_order',
    mark: 'WSS-2',
    redirect: '/test1_1',
    component: Myweb,
    meta: {
      title: '我的订单',
      listShow: false,
      divShow: false,
      icon: 'icon-a-lujing268'
    },
    children: [
      {
        path: '/sold',
        name: 'sold',
        mark: 'WSS-2001',
        meta: {
          title: '我卖出的',
          notCache: true
        },
        component: () =>
          import(/* webpackChunkName: "myweb" */ '@/views/business/sold.vue')
      },
      {
        path: '/bought',
        name: 'bought',
        mark: 'WSS-2002',
        meta: {
          title: '我买到的',
          notCache: true
        },
        component: () =>
          import(/* webpackChunkName: "myweb" */ '@/views/business/bought.vue')
      }
    ]
  },
  {
    path: '/shopmanagement',
    name: 'myweb_shopmanagement',
    mark: 'WSS-3',
    meta: {
      listShow: false,
      title: '店铺管理',
      hideInMenu: true,
      divShow: false,
      icon: 'icon-a-ziyuan11'
    },
    component: Myweb,
    children: [
      {
        path: '/storeList',
        name: 'storeList',
        mark: 'WSS-3000',
        meta: {
          title: '店铺列表',
          notCache: true
        },
        component: () =>
          import(
            /* webpackChunkName: "myweb" */ '@/views/myweb/storeList/index.vue'
          )
      },
      {
        path: '/shopInformation',
        name: 'shopInformation',
        mark: 'WSS-3001',
        meta: {
          title: '店铺信息',
          notCache: true
        },
        component: () =>
          import(
            /* webpackChunkName: "myweb" */ '@/views/myweb/shopmanagement/shopInformation'
          )
      },
      {
        path: '/Shopdecoration',
        name: 'Shopdecoration',
        mark: 'WSS-3002',
        meta: {
          title: '店铺装修',
          notCache: true
        },
        component: () =>
          import(
            /* webpackChunkName: "myweb" */ '@/views/myweb/shopmanagement/Shopdecoration'
          )
      },
      {
        path: '/warehouse',
        name: 'warehouse',
        mark: 'WSS-3003',
        meta: {
          title: '仓库库存',
          notCache: true
        },
        component: () =>
          import(
            /* webpackChunkName: "myweb" */ '@/views/myweb/shopmanagement/warehouse'
          )
      }
    ]
  },
  // {
  //   path: '/orderInformation',
  //   name: 'orderInformation',
  //   component: () => import('@/views/orderInformation/orderInformation.vue')
  // },
  {
    path: '/goodsManage',
    name: 'myweb_goodsManage',
    mark: 'WSS-4',
    meta: {
      title: '商品管理',
      listShow: false,
      divShow: false,
      icon: 'icon-a-lujing270'
    },

    component: Myweb,
    children: [
      {
        path: '/goodsList',
        name: 'goodsList',
        mark: 'WSS-4001',
        meta: {
          title: '商品列表',
          notCache: true
        },
        component: () =>
          import(
            /* webpackChunkName: "myweb" */ '@/views/myweb/goods/goodsManage/goodsList'
          )
      }
      // {
      //   path: '/editGood',
      //   name: 'editGood',
      //   mark: 'WSS-4000',
      //   meta: {
      //     title: '编辑商品',
      //     notCache: true
      //   },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "myweb" */ '@/views/myweb/goods/goodsManage/editGood'
      //     )
      // }
    ]
  },
  {
    path: '/salesManage',
    name: 'myweb_salesManage',
    mark: 'WSS-9',
    meta: {
      title: '营销管理',
      listShow: false,
      divShow: false,
      icon: 'icon-a-lujing270'
    },
    component: Myweb,
    children: [
      {
        path: '/storeActivity',
        name: 'storeActivity',
        mark: 'WSS-9001',
        meta: {
          title: '店铺活动',
          notCache: true
        },
        component: () => import('@/views/myweb/salesManage/storeActivity')
      }
    ]
  },
  // 编辑商品完整页面
  {
    path: '/editGood',
    name: 'editGood',
    component: () =>
      import(
        /* webpackChunkName: "myweb" */ '@/views/myweb/goods/goodsManage/editGood'
      )
  },
  // 编辑商品保存并上架完整页面
  {
    path: '/successPage',
    name: 'successPage',
    component: () =>
      import(
        /* webpackChunkName: "myweb" */ '@/views/myweb/goods/goodsManage/successPage'
      )
  },

  // {
  //   path: '/goods',
  //   name: 'myweb_goods',
  //   mark: 'WSS-4',
  //   meta: {
  //     title: '商品管理',
  //     listShow: false,
  //     divShow: false,
  //     icon: 'icon-a-lujing270'
  //   },

  //   component: Myweb,
  //   children: [
  //     {
  //       path: '/goodsManagement',
  //       name: 'goodsManagement',
  //       mark: 'WSS-4001',
  //       meta: {
  //         title: '商品列表',
  //         notCache: true
  //       },
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "myweb" */ '@/views/myweb/goods/goodsManagement'
  //         )
  //     },
  //     // {
  //     //   path: '/goodsApplyfort',
  //     //   name: 'goodsApplyfort',
  //     //   mark: 'WSS-4002',
  //     //   meta: {
  //     //     title: '品牌申请',
  //     //     notCache: true
  //     //   },
  //     //   component: () =>
  //     //     import(
  //     //       /* webpackChunkName: "myweb" */ '@/views/myweb/goods/goodsApplyfort'
  //     //     )
  //     // },
  //     {
  //       path: '/goodsRankManage',
  //       name: 'goodsRankManage',
  //       mark: 'WSS-4003',
  //       meta: {
  //         title: '销价级别管理',
  //         notCache: true
  //       },
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "myweb" */ '@/views/myweb/goods/goodsRankManage'
  //         )
  //     },
  //     {
  //       path: '/goodsPartsManage',
  //       name: 'goodsPartsManage',
  //       mark: 'WSS-4004',
  //       meta: {
  //         title: '价格管理',
  //         notCache: true
  //       },
  //       component: () =>
  //         import(
  //           /* webpackChunkName: "myweb" */ '@/views/myweb/goods/goodsPartsManage'
  //         )
  //     }
  //   ]
  // },
  // {
  //   path: '/lessee',
  //   name: 'myweb_lessee',
  //   component: Myweb,
  //   mark: 'WSS-5',
  //   meta: {
  //     icon: 'icon-a-lujing268',
  //     title: '极配自营',
  //     listShow: false
  //   },
  //   children: [
  //     {
  //       path: '/lesseeRelevanceShop',
  //       name: 'lesseeRelevanceShop',
  //       mark: 'WSS-5001',
  //       meta: {
  //         icon: 'md-funnel',
  //         title: '租户关联门店',
  //         notCache: true
  //       },
  //       component: () => import('@/views/myweb/lessee/relevanceShop.vue')
  //     }
  //   ]
  // },
  {
    path: '/accountManage ',
    name: 'myweb_accountManage',
    mark: 'WSS-5',
    meta: {
      title: '账号管理',
      listShow: false,
      hideInMenu: true,
      divShow: false,
      icon: 'icon-a-lujing271'
    },
    component: Myweb,
    children: [
      {
        path: '/personalData',
        name: 'personalData',
        mark: 'WSS-5001',
        meta: {
          title: '个人资料',
          notCache: true
        },
        component: () =>
          import(/* webpackChunkName: "myweb" */ '@/views/myweb/personalData')
      },
      {
        path: '/address',
        name: 'address',
        mark: 'WSS-5002',
        meta: {
          title: '收货地址',
          notCache: true
        },
        component: () =>
          import(
            /* webpackChunkName: "myweb" */ '@/views/myweb/address/index.vue'
          )
      },
      {
        path: '/invoice',
        name: 'invoice',
        mark: 'WSS-5003',
        meta: {
          title: '发票设置',
          notCache: true
        },
        component: () =>
          import(
            /* webpackChunkName: "myweb" */ '@/views/myweb/invoice/index.vue'
          )
      }
    ]
  },
  // 财务管理
  {
    path: '/financeregulate',
    name: 'myweb_financeregulate',
    mark: 'WSS-8',
    meta: {
      title: '财务管理',
      listShow: false,
      hideInMenu: true,
      divShow: false,
      icon: 'icon-caiwufenxi'
    },
    component: Myweb,
    children: [
      {
        path: '/brokerdealer',
        name: 'brokerdealer',
        mark: 'WSS-8001',
        meta: {
          title: '自营挂账',
          notCache: true
        },
        component: () =>
          import(
            /* webpackChunkName: "myweb" */ '@/views/myweb/financeregulate/brokerdealer/index.vue'
          )
      },
      {
        path: '/alliance',
        name: 'alliance',
        mark: 'WSS-8002',
        meta: {
          title: '联盟挂账',
          notCache: true
        },
        component: () =>
          import(
            /* webpackChunkName: "myweb" */ '@/views/myweb/financeregulate/alliance/index.vue'
          )
      }
    ]
  },
  // 组织管理本次不做
  {
    path: '/organization',
    name: 'myweb_organization',
    mark: 'WSS-6',
    meta: {
      title: '组织管理',
      listShow: false,
      hideInMenu: true,
      icon: 'icon-a-lujing272'
    },
    // hidden: false,
    component: Myweb,
    redirect: '/staffManagement',
    children: [
      {
        path: '/staffManagement',
        name: 'staffManagement',
        mark: 'WSS-6001',
        meta: {
          title: '员工列表',
          notCache: true
        },
        component: () =>
          import(
            /* webpackChunkName: "myweb" */ '@/views/myweb/organization/staffManagement/index.vue'
          )
      },
      {
        path: '/roleManagement',
        name: 'roleManagement',
        mark: 'WSS-6002',
        meta: {
          title: '角色管理',
          notCache: true
        },
        component: () =>
          import(
            /* webpackChunkName: "myweb" */ '@/views/myweb/organization/roleManagement/index.vue'
          )
      }
      // {
      //   path: '/linkmanManagement',
      //   name: 'linkmanManagement',
      //   mark: 'WSS-6003',
      //   meta: {
      //     title: '联系人管理',
      //     notCache: true
      //   },
      //   component: () =>
      //     import(
      //       /* webpackChunkName: "myweb" */ '@/views/myweb/organization/linkmanManagement/index.vue'
      //     )
      // }
    ]
  },

  {
    path: '/503',
    name: 'error_503',
    component: () => import('@/views/base/error-page/503.vue')
  },
  {
    path: '*',
    name: 'error_404',
    component: () => import('@/views/base/error-page/404.vue')
  }
]
